Namespace 'Common.Dashboard.Charts'

class Common.Dashboard.Charts.ChartsLoadingPlaceholderView extends Backbone.View
  template: JST['backbone/templates/common/dashboard/charts/charts_loading_placeholder']
  className: 'charts-loading-placeholder'

  render: =>
    @$el.html(@template())
    @
